import { render } from "./left-panel.vue?vue&type=template&id=64e91c1c"
import script from "./left-panel.vue?vue&type=script&lang=js"
export * from "./left-panel.vue?vue&type=script&lang=js"
script.render = render

export default script